import { Constant, FullMethodDispatcher } from "@pdfking/tfunc"

import type { VirtualFile } from "../types/files/VirtualFile"

import { ContentType } from "../types/files/ContentType"
import { VirtualFileType } from "../types/files/VirtualFileType"

export const FileContentType = FullMethodDispatcher<[VirtualFile], ContentType>(
  {
    [VirtualFileType.GENERATED_FILE]: file => file.type,
    [VirtualFileType.MULTI_PAGE_PDF]: Constant(ContentType.PDF),
    [VirtualFileType.REMOTE_FILE]: file => file.type,
    [VirtualFileType.REMOTE_FILE_CHUNK]: Constant(ContentType.BYTES),
    [VirtualFileType.SINGLE_PAGE_IMAGE]: Constant(ContentType.PNG),
    [VirtualFileType.SINGLE_PAGE_PDF]: Constant(ContentType.PDF),
    [VirtualFileType.ZIP_FILE]: Constant(ContentType.ZIP),
  }
)
